import { MEDIA_QUERY } from 'utils/enum/Core';

export default class MessageCenterLayoutStyle {
    static content(theme = {}) {
        return ({
            main: {
                flex: 1,
                display: 'flex',
                overflow: 'hidden',
                flexDirection: 'column',
            },
            title: {
                color: theme.palette.text.boulderGray,
            },
            detail: {
                display: 'flex',
                flexGrow: 1,
                overflow: 'auto',
                [`@media (max-width: ${MEDIA_QUERY.W_430}px)`]: {
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 10,
                    backgroundColor: theme.palette.background.white,
                },
            },
            detailHidden: {
                [`@media (max-width: ${MEDIA_QUERY.W_430}px)`]: {
                    display: 'none',
                },
            },
            listContainer: {
                [`@media (max-width: ${MEDIA_QUERY.W_430}px)`]: {
                    width: '100%',
                    overflow: 'hidden',
                },
            },
            listHidden: {
                [`@media (max-width: ${MEDIA_QUERY.W_430}px)`]: {
                    display: 'none',
                },
            },
            customer: {
                color: theme.palette.text.butterflyBush,
                marginBottom: theme.spacing(0.5),
            },
            customerInformation: {
                padding: theme.spacing(2, 1),
                backgroundColor: theme.palette.background.white,
                marginBottom: theme.spacing(2),
                display: 'flex',
                '& > div:nth-child(1)': {
                    width: '80%',
                },
                '& > div:nth-child(2)': {
                    width: '20%',
                    fontSize: '18px',
                    display: 'flex',
                    justifyContent: 'flex-end',
                },
                [`@media (max-width: ${MEDIA_QUERY.W_430}px)`]: {
                    '& > div:nth-child(1)': {
                        width: '100%',
                    },
                    '& > div:nth-child(2)': {
                        display: 'none',
                    },
                },
            },
            opportunityContainer: {
                padding: theme.spacing(1),
                height: '100%',
                overflow: 'auto',
                width: '690px',
                minWidth: '690px',
                [`@media (max-width: ${MEDIA_QUERY.W_430}px)`]: {
                    display: 'none',
                },
            },
            column: {
                position: 'relative',
                height: '100%',
            },
            leftSection: {
                borderLeft: `1px solid ${theme.palette.border.gallery}`,
                background: theme.palette.background.default,
                [`@media (max-width: ${MEDIA_QUERY.W_430}px)`]: {
                    borderLeft: 'none',
                },
            },
            label: {
                color: theme.palette.text.minsk,
                fontSize: '14px',
                fontWeight: '500',
                textAlign: 'right',
                marginRight: theme.spacing(1),
                lineHeight: '20px',
            },
            value: {
                fontSize: '14px',
                fontWeight: '500',
                lineHeight: '20px',
                color: theme.palette.text.gray,
            },
        });
    }
}
